module.exports = __webpack_public_path__ + "static/media/core3.9806c8bb.jpeg";